import * as React from "react";
import { Modal, ButtonGroup, Alert } from "react-bootstrap"

import { BaseFormComponent } from "./BaseFormComponent"

export abstract class BaseDialogFormComponent<TModel> extends BaseFormComponent<TModel> {
    protected constructor(props: TModel) {
        super(props);
    }

    abstract title(): any;
    abstract body(): any;
    abstract buttons(): JSX.Element[];
    protected error() {
        return this.state.errorMessage ? <Alert bsStyle="danger">{this.state.errorMessage}</Alert> : null;
    }

    render(): JSX.Element {
        return <form className="static-modal" onSubmit={(e: React.FormEvent<{}>) => e.preventDefault()}>
                   <Modal.Dialog>
                       <Modal.Header>
                           <Modal.Title>{this.title() }</Modal.Title>
                       </Modal.Header>

                       <Modal.Body>
                           {this.body() }
                       </Modal.Body>

                       <Modal.Footer>
                           <ButtonGroup>{this.buttons() }</ButtonGroup>
                           {this.error() }
                       </Modal.Footer>

                   </Modal.Dialog>
               </form>;
    }
}



// WEBPACK FOOTER //
// ./Scripts/React/Component/BaseDialogFormComponent.tsx